import { render } from "./PasswordReset.vue?vue&type=template&id=4d6d0cd1"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gizmorilla.com/toolbox.gizmorilla.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__